export const add = `
<svg enable-background="new 0 0 42 42" version="1.1" viewBox="0 0 42 42" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
<polygon points="42 19 23 19 23 0 19 0 19 19 0 19 0 23 19 23 19 42 23 42 23 23 42 23"/>
</svg>
`;
